import { useCallback, useEffect, useRef } from 'react';
import { useSetAtom } from 'jotai';
import type { StartTimeFilterModel } from './types';
import { dashboardFilterAtom } from '../../filterAtom';

export const useStartTimeFilter = (model: StartTimeFilterModel | null) => {
  const setDashboardFilter = useSetAtom(dashboardFilterAtom);
  const previousModelReference = useRef<StartTimeFilterModel | null>(null);

  const updateAtom = useCallback(
    (newModel: StartTimeFilterModel | null) =>
      setDashboardFilter((previousFilter) => ({
        ...previousFilter,
        beforeStartDate: newModel?.type === 'lessThan',
        startDate: newModel?.startDate || null,
        startDateTo: newModel?.startDateTo || null,
      })),
    [setDashboardFilter]
  );

  useEffect(() => {
    const hasModelChanged =
      JSON.stringify(model) !== JSON.stringify(previousModelReference.current);

    if (hasModelChanged) {
      updateAtom(model);
      previousModelReference.current = model;
    }
  }, [model, updateAtom]);
};
